import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { TransportOrderDetailsDto } from "../../../models/transport/transportOrder";
import { useTheme } from "@mui/material/styles";

export interface TransportDetailsProps {
    order: TransportOrderDetailsDto;
}

export const TransportDetails = ({ order } : TransportDetailsProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const blue: string = theme.palette.blue.dark;

    return (
        <>
            <Box sx={{ display: "flex", alignItems: "center", pt: 2, pl: 2, my: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold", color: blue }}>{t("transport.order.details")}</Typography>
            </Box>
            <Box sx={{
                borderColor: "#dedede",
                borderRadius: "10px",
                p: 2,
                mx: 2,
                backgroundColor: "#f4f4f4"
            }}
            >
                <Typography variant="subtitle2" color="primary.dark" sx={{ pb: 1, wordBreak: "break-all" }}>
                    {order?.transportDetails}
                </Typography>
            </Box>
        </>
    );
};
